<script>
import AkButtonValidationV2 from './AkButtonValidationV2.vue';
import AkButtonActionV2 from './AkButtonActionV2.vue';

export default {
  components: {AkButtonActionV2, AkButtonValidationV2},
  props: {
    cancelLabel: {
      type: String,
      required: false,
      default: 'Annuler',
    },
    validateLabel: {
      type: String,
      required: true,
    },
  },
  emits: ['action', 'cancel'],
  methods: {
    init() {
      this.$refs.btnUpdate.init();
    },
    clickAction() {
      this.$emit('action');
    },
    clickCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <div class="grid grid-cols-4 gap-4 mt-4">
    <AkButtonActionV2
      :label="this.cancelLabel"
      btn-class="col-start-2 col-end-2 btn-transparent"
      @click="clickCancel()" />
    <AkButtonValidationV2
      ref="btnUpdate"
      :label="this.validateLabel"
      :little="false"
      btn-class="col-start-3 col-end-5 btn-blue"
      @action="clickAction" />
  </div>
</template>
